<template>



  <div class="container mt-5">
    <div class="row">
      <div class="col">

        <!--         INICIO BOTON PRODUCTO -->

        <div class="boton-agregar">
          <button data-text="Awesome" class="button" data-bs-toggle="modal" data-bs-target="#exampleModal">
            <span class="actual-text">&nbsp;+producto&nbsp;</span>
            <span class="hover-text" aria-hidden="true">&nbsp;+producto&nbsp;</span>
          </button>

            <input v-model="nameSearch" class="form-control input-search me-2" type="search" placeholder="nombre producto" aria-label="Search">
            <button @click="buscarProductoPorNombre" class="button-search " type="button">Buscar</button>

        </div>
        <!--         FIN BOTON PRODUCTO -->


        <!--         INICIO TABLA-->

        <table class="table table-dark table-striped">
          <thead>
          <tr>
            <th scope="col">Id</th>
            <th scope="col">Nombre</th>
            <th scope="col">Url</th>
            <th scope="col">Descripción</th>
            <th scope="col">Precio</th>
            <th scope="col">Categoria</th>
            <th scope="col">Editar</th>
            <th scope="col">Eliminar</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="producto in productos.contenido">
            <th scope="row">{{producto.id}}</th>
            <td>{{producto.name}}</td>
            <td>{{producto.imgUrl.substring(8,20)}}</td>
            <td>{{producto.description}}</td>
            <td>{{producto.price}}</td>
            <td>{{producto.categoria.nombre}}</td>
            <td>
              <button @click="obtenerId(producto.id)" type="button" class="btn btn-outline-warning" data-bs-toggle="modal" data-bs-target="#updateModal">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil-square" viewBox="0 0 16 16">
                  <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"></path>
                  <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"></path>
                </svg>
              </button>
            </td>
            <td>
              <button @click="eliminarProducto(producto.id)" type="button" class="btn btn-outline-danger">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
                  <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"></path>
                  <path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"></path>
                </svg>
              </button>
            </td>
          </tr>
          </tbody>
        </table>

      </div>
    </div>
  </div>


  <!--  PAGINACIÓN-->

  <div class="container-paginacion" v-if="productos.totalPaginas >= 1">
    <nav aria-label="...">
      <ul class="pagination">

        <li class="page-item link-pagination" >
          <a @click="paginacion(productos.numeroPagina - 1)" class="page-link" v-if="productos.numeroPagina > 1">
            {{productos.numeroPagina - 1}}
          </a>
        </li>
        <li class="page-item active" aria-current="page">
          <span class="page-link bg-success">
            {{productos.numeroPagina}}
          </span>
        </li>
        <li class="page-item link-pagination">
          <a @click="paginacion(productos.numeroPagina + 1)" class="page-link" v-if="productos.numeroPagina < productos.totalPaginas">
            {{productos.numeroPagina + 1}}
          </a>
        </li>
        <li class="page-item"><a class="page-link" > --- </a></li>
        <li class="page-item link-pagination">
          <a @click="paginacion(productos.totalPaginas)" class="page-link" >
            {{productos.totalPaginas}}
          </a>
        </li>

      </ul>
    </nav>
  </div>
  <!-- FIN PAGINACIÓN-->




  <!--  INICIO MODAL GUARDAR-->

  <!-- Modal -->
  <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Agregar Producto</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">

          <div class="input-group">
            <input v-model="productoDto.name" required="" type="text" name="text" autocomplete="off" class="form-select input">
            <label class="user-label">Nombre</label>
          </div>

          <div class="input-group mt-5">
            <input v-model="productoDto.imgUrl" required="" type="text" name="text" autocomplete="off" class="form-select input">
            <label class="user-label">Imagen</label>
          </div>

          <div class="input-group mt-5">
            <input v-model="productoDto.description" required="" type="text" name="text" autocomplete="off" class="form-select input">
            <label class="user-label">Descripción</label>
          </div>

          <div class="input-group mt-5">
            <input v-model="productoDto.price" required="" type="number" name="text" autocomplete="off" class="form-select input">
            <label class="user-label">Precio</label>
          </div>

          <div class="input-group mt-5">
            <select v-model="productoDto.categoria" class="form-select" id="inputGroupSelect01"   name="text">
              <option v-for="categoria in categorias" :value="categoria.id">{{categoria.nombre}}</option>
            </select>
          </div>


        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
          <button @click="guardarProducto" type="button" class="btn btn-primary">Guardar</button>
        </div>
      </div>
    </div>
  </div>
  <!--  FIN MODAL GUARDAR-->


  <!--  INICIO MODAL ACTUALIZAR-->

  <!-- Modal -->
  <div class="modal fade" id="updateModal" tabindex="-1" aria-labelledby="updateModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Actualizar Categoria</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">

          <div class="input-group">
            <input v-model="nombreProducto.name" required="" type="text" name="text" autocomplete="off" class="form-select input">
            <label class="user-label">Nombre</label>
          </div>

          <div class="input-group mt-5">
            <input v-model="nombreProducto.imgUrl" required="" type="text" name="text" autocomplete="off" class="form-select input">
            <label class="user-label">Imagen</label>
          </div>

          <div class="input-group mt-5">
            <input v-model="nombreProducto.description" required="" type="text" name="text" autocomplete="off" class="form-select input">
            <label class="user-label">Descripción</label>
          </div>

          <div class="input-group mt-5">
            <input v-model="nombreProducto.price" required="" type="number" name="text" autocomplete="off" class="form-select input">
            <label class="user-label">Precio</label>
          </div>

          <div class="input-group mt-5">
            <select v-model="nombreProducto.categoria" class="form-select" id="inputGroupSelect01"   name="text">
              <option v-for="categoria in categorias" :value="categoria.id">{{categoria.nombre}}</option>
            </select>
          </div>


        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
          <button @click="editarProducto" type="button" data-bs-dismiss="modal" class="btn btn-primary">Guardar</button>
        </div>
      </div>
    </div>
  </div>
  <!--  FIN MODAL ACTUALIZAR-->


</template>

<script>
import {useStore} from "vuex";
import {computed, onBeforeMount, ref} from "vue";

export default {
  name: "Producto",
  setup(){

    const store = useStore();
    const url = computed(() => store.state.userStore.url);
    const token = computed(() => store.state.userStore.token);
    let productoDto = ref({});
    let nombreProducto = ref({});
    let productos = ref([]);
    let nameSearch = ref("");

    let categorias = ref([]);

    onBeforeMount(() => {
      cargarProductos();
      cargarCategorias();
    });

    const cargarProductos = async () => {
      const res = await fetch(`${url.value}/api/producto`);
      productos.value = await res.json();
    }

    const cargarCategorias = async () => {
      const res = await fetch(`${url.value}/api/categoria`);
      categorias.value = await res.json();
    }



    const guardarProducto = async () => {
      if (productoDto.value.categoria == undefined) return swal("Error!", `Debe elegir una categoria`, "error");
      productoDto.value.categoria = {id:productoDto.value.categoria}
      const res = await fetch(`${url.value}/api/producto`, {
        method:'POST',
        mode:'cors',
        headers:{
          'token':token.value,
          'Content-Type': 'application/json'
        },
        body:JSON.stringify(productoDto.value)
      });
      const datos = await res.json();
      if(res.status == 201){
        productoDto.value.name = "";
        productoDto.value.imgUrl = "";
        productoDto.value.description = "";
        productoDto.value.price = "";
        productoDto.value.categoria = "";
        swal("Excelente!", "Categoria guardada con exito!", "success");
        productos.value.contenido.push(datos);
      }
      if (res.status == 400){
        swal("Error!", `${datos.mensaje}`, "error");
      }

    }

    const obtenerId = async (id) => {

      const producto = productos.value.contenido.find(cat => cat.id == id);

      nombreProducto.value.id = id;
      nombreProducto.value.name = producto.name;
      nombreProducto.value.imgUrl = producto.imgUrl;
      nombreProducto.value.description = producto.description;
      nombreProducto.value.price = producto.price;
      nombreProducto.value.categoria = producto.categoria.id;


    }

    const editarProducto = async () => {

      if (nombreProducto.value.categoria == undefined) return swal("Error!", `Debe elegir una categoria`, "error");
      nombreProducto.value.categoria = {id:nombreProducto.value.categoria}


      const res = await fetch(`${url.value}/api/producto/${nombreProducto.value.id}`,{
        method:'PUT',
        mode:'cors',
        headers:{
          'token':token.value,
          'Content-Type': 'application/json'
        },
        body:JSON.stringify(nombreProducto.value)
      });
      const datos = await res.json();
      if (res.status == 201){
        productos.value.contenido.map(cat =>{
          if (cat.id == nombreProducto.value.id) {
            cat.name = datos.name;
            cat.imgUrl = datos.imgUrl;
            cat.description = datos.description;
            cat.price = datos.price;
            cat.categoria = datos.categoria;
          }
        });
        swal("Excelente!", "Categoria Actualizada con exito!", "success");
      }


    }


    const paginacion = async (pagina) => {
      const res = await fetch(`${url.value}/api/producto?page=${pagina}`);
      productos.value = await res.json();
    }


    const eliminarProducto = async (id) => {

      swal({
        title: "Estas seguro?",
        text: "una vez borrado, no se pordra recuperar",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      })
          .then(async (willDelete) => {
            if (willDelete) {
              const res = await fetch(`${url.value}/api/producto/${id}`,{
                mode:'cors',
                method:'DELETE',
                headers:{
                  'token':token.value,
                  'Content-Type': 'application/json'
                }
              });
              if (res.status == 204){
                productos.value.contenido = productos.value.contenido.filter(cat => cat.id != id);
                swal("ha sido eliminado con exito!", {
                  icon: "success",
                });
              }
              if (res.status == 400){
                const datos = await res.json();
                swal("Error!", `${datos.mensaje}`, "error");
              }
            }
          });

    }


    const buscarProductoPorNombre = async () => {
      const res = await fetch(`${url.value}/api/producto?name=${nameSearch.value}`);
      productos.value = await res.json();
    }







    return {
      cargarProductos, productos, productoDto, guardarProducto, categorias, paginacion, editarProducto,
      obtenerId, nombreProducto, eliminarProducto, nameSearch, buscarProductoPorNombre
    }

  }
}
</script>











<style scoped>

.col {
  display: grid;
  justify-content: center;
  align-items: center;
}

.table-dark {
  max-width: 60vw;
}

.boton-agregar {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;

}

.button {
  margin: 0;
  background: transparent;
  padding: 0;
  border: none;
}

/* button styling */
.button {
  --border-right: 6px;
  --text-stroke-color: rgba(255,255,255,0.6);
  --animation-color: #ff7337;
  --fs-size: 2em;
  letter-spacing: 3px;
  text-decoration: none;
  font-size: var(--fs-size);
  font-family: "Arial";
  position: relative;
  text-transform: uppercase;
  color: transparent;
  -webkit-text-stroke: 1px var(--text-stroke-color);
}
/* this is the text, when you hover on button */
.hover-text {
  position: absolute;
  box-sizing: border-box;
  content: attr(data-text);
  color: var(--animation-color);
  width: 0%;
  inset: 0;
  border-right: var(--border-right) solid var(--animation-color);
  overflow: hidden;
  transition: 0.5s;
  -webkit-text-stroke: 1px var(--animation-color);
}
/* hover */
.button:hover .hover-text {
  width: 100%;
  filter: drop-shadow(0 0 23px var(--animation-color))
}




.input-group {
  position: relative;
}

.input {
  border: solid 1.5px #9e9e9e;
  border-radius: 1rem;
  background: none;
  padding: 1rem;
  font-size: 1rem;
  color: #f5f5f5;
  transition: border 150ms cubic-bezier(0.4,0,0.2,1);
}

.user-label {
  position: absolute;
  left: 15px;
  color: #e8e8e8;
  pointer-events: none;
  transform: translateY(1rem);
  transition: 150ms cubic-bezier(0.4,0,0.2,1);
}

.input:focus, input:valid {
  outline: none;
  border: 1.5px solid #1a73e8;
}

.input:focus ~ label, input:valid ~ label {
  transform: translateY(-90%) scale(0.8);
  padding: 0 .2em;
  color: #2196f3;
}

.modal-content {
  background-image: linear-gradient(to bottom right, #734ebd, #881e6f);
  color: white;
}

.container-paginacion {
  display: flex;
  justify-content: center;
  margin-top: 10vh;
  margin-bottom: 10vh;
}

.page-item {
  padding: 5px;
}

.link-pagination {
  cursor: pointer;
}





.button-search {
  width: 10vw;
  background-color: #dd51a8;
  color: white;
  border-color: #dd51a8;
  border-radius: 10px;
}

.button-search:hover {
  border-color: #04BF9D;
  background-color: #04BF9D;
  color: white;
}

.button-search:active {
  border-color: #04BF9D;
  background-color: #47887a;
  color: white;
  border-radius: 10px;
  box-shadow:  -2px -2px 18px rgb(68, 192, 166);
}

.input-search {
  color: whitesmoke;
  margin-left: 7vw;
  max-width: 15vw;
  border-top: none;
  border-right: none;
  border-left: none;
  background-color: transparent;
  border-radius: 0px;
  padding-left: 20px;
  outline:none !important;
}

.input-search:focus {
  color: whitesmoke;
  font-size: 18px;
  padding-left: 20px;
  border: 1px solid hsla(328, 33%, 67%, 0.89);
  border-radius: 20px;
  box-shadow: none;
}
</style>